module.exports = __webpack_public_path__ + "static/media/Sport_5_t.1e0aca9e.jpg";